export enum StorageField {
    ID = 'id',
    NAME = 'name',
    ADDRESS = 'address',
    TYPE = 'type',
    ADDRESS_ID = 'addressId',
    CADASTRAL_NUMBER = 'cadastralNumber'
}
